import { FLIPPER_KEYS } from '~/store/flippers/const'
import { FlipperResponseMap } from './types'

export enum BLOCKCHAIN_ADDRESS_ACTIONS {
  SET_BLOCKCHAIN_ADDRESS_LIST = 'BLOCKCHAIN_ADDRESS_ACTIONS.SET_BLOCKCHAIN_ADDRESS_LIST',
  SET_FI_LIST = 'BLOCKCHAIN_ADDRESS_ACTIONS.SET_FI_LIST',
  SET_MAX_ADDRESS_AMOUNT = 'BLOCKCHAIN_ADDRESS_ACTIONS.SET_MAX_ADDRESS_AMOUNT',
  SET_ADDRESS_QUOTA = 'BLOCKCHAIN_ADDRESS_ACTIONS.SET_ADDRESS_QUOTA',
  UPDATE_BLOCKCHAIN_ADDRESS = 'BLOCKCHAIN_ADDRESS_ACTIONS.UPDATE_BLOCKCHAIN_ADDRESS',
  SET_FLIPPERS = 'BLOCKCHAIN_ADDRESS_ACTIONS.SET_FLIPPERS',
}

export const FLIPPER_RESPONSE_MAP: Partial<FlipperResponseMap> = {
  [FLIPPER_KEYS.WHITELISTING_IMPROVEMENT]: 'isWhitelistingImprovementEnabled',
} as const
